import React from 'react';
import {Box,Typography} from '@material-ui/core';


const Event = () => {
    return (
        <Box>
            <Typography>
                Event
            </Typography>
        </Box>
    );
}


export default Event;